import React from 'react';

function SwimT() {
  return <div></div>;
}

export default SwimT;
